import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { OperatorsAndVehiclesFormValues } from '../../../../forms/ActionForms/OperatorsAndVehicles/types';

export type ExternalCompaniesSelectionType = {
  company?: string;
  work?: string;
  operatorsNumber?: number | string;
  remove?: string;
  id?: string;
  workId?: string;
};

export type ExternalProps = {
  setValue: UseFormSetValue<OperatorsAndVehiclesFormValues>;
  getValues: UseFormGetValues<OperatorsAndVehiclesFormValues>;
  externalCompanies: {
    id: string;
    companyName: string;
    /**
     * Empresa dada de baja desde Gestión: no debe ofrecerse al seleccionar.
     * Opcional porque algún consumidor puede no pedirla todavía en su query —
     * ver el filtro del componente, que trata `undefined` como activa.
     */
    isActive?: boolean;
  }[];
  defaultValues: ExternalCompaniesSelectionType[];
  setDefaultExternals: (data: ExternalCompaniesSelectionType[]) => void;
};

// @deprecated - Use getExternalCompaniesColumnNames instead
export const columnNames = {
  company: {
    id: 'company',
    label: 'Empresa',
  },
  work: {
    id: 'work',
    label: 'Treball',
  },
  operatorsNumber: {
    id: 'operatorsNumber',
    label: 'Nº OP',
  },
  remove: {
    id: 'remove',
    label: '',
  },
};

// Dynamic column names with translations
export const getExternalCompaniesColumnNames = (t: any) => ({
  company: {
    id: 'company',
    label: t('externalCompanies.company'),
  },
  work: {
    id: 'work',
    label: t('externalCompanies.work'),
  },
  operatorsNumber: {
    id: 'operatorsNumber',
    label: t('externalCompanies.operatorsNumber'),
  },
  remove: {
    id: 'remove',
    label: '',
  },
});

export type cellExternalCompaniesTypes =
  | 'company'
  | 'operatorsNumber'
  | 'remove';
export type CellProps = {
  cell: cellExternalCompaniesTypes;
};
